import React, { useEffect } from "react";

import { useFeatureFlagToggle } from "Reducers/featureFlags/useFeatureFlagToggle";
import { toggleActivitiesOverlay } from "Reducers/metrics/settings.slice";
import TimeframeSelector from "src/organization/pages/project/environment/metrics/components/TimeframeSelector";
import useUpdateTimeframeUrl from "src/organization/pages/project/environment/metrics/hooks/useUpdateTimeframeUrl";
import { gridTimeframes } from "src/organization/pages/project/environment/metrics/resources/settings";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { ParseTimeDurationType } from "src/organization/pages/project/environment/metrics/utils/parseDimensions/types";
import { useAppDispatch } from "Store/hooks";

import { TabSyncProps } from "../TimeframeSelector/SyncTab";

import LastUpdated from "./lastupdated/LastUpdated";
import { ControlFilterContainer, Deployments } from "./style";
import { formatTimeFrame } from "./util";

type TimeframeControlProps = {
  deployment?: {
    enabled: boolean;
    onChange: (enabled: boolean) => any;
  };
  timeframe: {
    onChange: (timeframe: TimeFrameType) => void;
    timeframe: TimeFrameType;
    timeDuration?: ParseTimeDurationType;
  };
  pollInterval?: any;
  lastUpdated?: Date;
  isUpdating?: boolean;
  children?: React.ReactNode;
  tabSync?: TabSyncProps;
};

const TimeframeControl = (props: TimeframeControlProps) => {
  const dispatch = useAppDispatch();
  const {
    deployment,
    timeframe,
    pollInterval,
    lastUpdated,
    isUpdating,
    children,
    tabSync
  } = props;

  useUpdateTimeframeUrl(timeframe.timeframe);

  const onTimeChange = (range: { from: Date; to: Date } | string) => {
    switch (typeof range) {
      case "string":
        timeframe.onChange({ id: range });
        break;
      default:
        timeframe.onChange(range);
    }
  };

  const [deploymentOverlayEnabled] = useFeatureFlagToggle(
    "ENABLE_DEPLOYMENT_OVERLAY"
  );

  useEffect(() => {
    dispatch(toggleActivitiesOverlay(deployment));
  }, [dispatch, deployment]);

  return (
    <div>
      <LastUpdated
        pollInterval={pollInterval}
        isUpdating={isUpdating}
        timeframe={timeframe.timeframe}
        lastUpdated={lastUpdated}
      />
      <ControlFilterContainer>
        {deploymentOverlayEnabled && deployment && (
          <Deployments
            label="Deployments"
            checked={deployment.enabled}
            onChange={() => deployment.onChange(!deployment.enabled)}
          />
        )}

        {children}

        <TimeframeSelector
          rangeFormatter={formatTimeFrame}
          selectedTimeframe={timeframe.timeframe}
          timeframes={gridTimeframes}
          onChange={onTimeChange}
          tabSync={tabSync}
          timeDuration={timeframe.timeDuration}
        />
      </ControlFilterContainer>
    </div>
  );
};
export default TimeframeControl;
